import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border p-3 mt-4" }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = { class: "form-group mb-4 col" }
const _hoisted_4 = { class: "form-group mb-4 col" }

import { computed } from 'vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MetricTimeWindowSettings',
  props: {
    startOffset: {},
    length: {}
  },
  emits: ["update:startOffset", "update:length"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    const startOffsetModel = computed({
        get: () => props.startOffset,
        set: (v: number | null) => emit('update:startOffset', v)
    })

    const lengthModel = computed({
        get: () => props.length,
        set: (v: number | null) => emit('update:length', v)
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("legend", { class: "w-auto px-2 text-primary" }, " Time Window ", -1 /* CACHED */)),
    _cache[7] || (_cache[7] = _createElementVNode("small", { class: "form-text text-muted mb-3" }, " Limits which months are included in the calculation. This applies independently of schedule-dependent settings. ", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Start offset "),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("label", {
          for: "timeWindowStartOffset",
          class: "form-label"
        }, " Start offset (months): ", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          id: "timeWindowStartOffset",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startOffsetModel).value = $event)),
          type: "number",
          min: "0",
          step: "1",
          class: "form-control",
          "data-testid": "time-window-start-offset",
          placeholder: "Optional..."
        }, null, 512 /* NEED_PATCH */), [
          [
            _vModelText,
            startOffsetModel.value,
            void 0,
            { number: true }
          ]
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("small", { class: "form-text text-muted" }, [
          _createTextVNode(" Optional. Zero-based offset into the metric’s monthly values. "),
          _createElementVNode("strong", null, "0"),
          _createTextVNode(" starts at the first month, "),
          _createElementVNode("strong", null, "24"),
          _createTextVNode(" starts at month 25 (year 3). ")
        ], -1 /* CACHED */))
      ]),
      _createCommentVNode(" Length "),
      _createElementVNode("div", _hoisted_4, [
        _cache[4] || (_cache[4] = _createElementVNode("label", {
          for: "timeWindowLength",
          class: "form-label"
        }, " Window length (months): ", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          id: "timeWindowLength",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lengthModel).value = $event)),
          type: "number",
          min: "1",
          step: "1",
          class: "form-control",
          "data-testid": "time-window-length",
          placeholder: "Optional..."
        }, null, 512 /* NEED_PATCH */), [
          [
            _vModelText,
            lengthModel.value,
            void 0,
            { number: true }
          ]
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("small", { class: "form-text text-muted" }, " Optional. Number of months to include. Leave blank to include all months from the start offset onward. ", -1 /* CACHED */))
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("small", { class: "form-text text-muted" }, [
      _createElementVNode("strong", null, "Examples:"),
      _createElementVNode("br"),
      _createElementVNode("strong", null, "First 36 months:"),
      _createTextVNode(" Start offset = 0, Length = 36."),
      _createElementVNode("br"),
      _createElementVNode("strong", null, "Year 3 only:"),
      _createTextVNode(" Start offset = 24, Length = 12."),
      _createElementVNode("br"),
      _createElementVNode("strong", null, "From year 4 onward:"),
      _createTextVNode(" Start offset = 36, Length empty. ")
    ], -1 /* CACHED */))
  ]))
}
}

})